import ArrowBack from 'shared/iconpack/icons/ArrowBack'
import ArrowLeft from 'shared/iconpack/icons/ArrowLeft'
import ArrowRight from 'shared/iconpack/icons/ArrowRight'
import ArrowUp from 'shared/iconpack/icons/ArrowUp'
import Avatar from 'shared/iconpack/icons/Avatar'
import BarChart from 'shared/iconpack/icons/BarChart'
import BreadcrumbSeparator from 'shared/iconpack/icons/BreadcrumbSeparator'
import BubbleChart from 'shared/iconpack/icons/BubbleChart'
import BurgerMenu from 'shared/iconpack/icons/BurgerMenu'
import Calendar from 'shared/iconpack/icons/Calendar'
import Clients from 'shared/iconpack/icons/Clients'
import Close from 'shared/iconpack/icons/Close'
import Comment from 'shared/iconpack/icons/Comment'
import Cutlery from 'shared/iconpack/icons/Cutlery'
import EmptyTable from 'shared/iconpack/icons/EmptyTable'
import Exit from 'shared/iconpack/icons/Exit'
import Filter from 'shared/iconpack/icons/Filter'
import Flag from 'shared/iconpack/icons/Flag'
import KeyAccess from 'shared/iconpack/icons/KeyAccess'
import KnowledgePlace from 'shared/iconpack/icons/KnowledgePlace'
import Link from 'shared/iconpack/icons/Link'
import Logs from 'shared/iconpack/icons/Logs'
import Minus from 'shared/iconpack/icons/Minus'
import MoreMenu from 'shared/iconpack/icons/MoreMenu'
import NoAccess from 'shared/iconpack/icons/NoAccess'
import NotFound from 'shared/iconpack/icons/NotFound'
import Notification from 'shared/iconpack/icons/Notification'
import OfficeApp from 'shared/iconpack/icons/OfficeApp'
import Orders from 'shared/iconpack/icons/Orders'
import Question from 'shared/iconpack/icons/Question'
import Reports from 'shared/iconpack/icons/Reports'
import SomeWrong from 'shared/iconpack/icons/SomeWrong'
import Staff from 'shared/iconpack/icons/Staff'
import Support from 'shared/iconpack/icons/Support'
import UnderMaintenance from 'shared/iconpack/icons/UnderMaintenance'
import Users from 'shared/iconpack/icons/Users'

import ArrowDown from '../icons/ArrowDown'
import Article from '../icons/Article'
import Bell from '../icons/Bell'
import BellOutline from '../icons/BellOutline'
import BoldClose from '../icons/BoldClose'
import Bookmark from '../icons/Bookmark'
import CashUser from '../icons/CashUser'
import Checked from '../icons/Checked'
import CheckedRound from '../icons/CheckedRound'
import CheckedSimple from '../icons/CheckedSimple'
import Circle from '../icons/Circle'
import Copy from '../icons/Copy'
import Cross from '../icons/Cross'
import Danger from '../icons/Danger'
import Docs from '../icons/Docs'
import Docx from '../icons/Docx'
import DoneSimple from '../icons/DoneSimple'
import Dots from '../icons/Dots'
import Download from '../icons/Download'
import EmptyBookmark from '../icons/EmptyBookmark'
import EmptyFiles from '../icons/EmptyFiles'
import Excel from '../icons/ExcelIcon'
import Eye from '../icons/Eye'
import EyeOutline from '../icons/EyeOutline'
import Favorites from '../icons/Favorites'
import File from '../icons/File'
import Folder from '../icons/Folder'
import GalleryIcon from '../icons/GalleryIcon'
import Home from '../icons/Home'
import House from '../icons/House'
import Jpeg from '../icons/Jpeg'
import Jpg from '../icons/Jpg'
import Load from '../icons/Load'
import LoyalStatus from '../icons/LoyalStatus'
import Mp4 from '../icons/Mp4'
import MyLocation from '../icons/MyLocation'
import Pdf from '../icons/Pdf'
import PdfFile from '../icons/PdfFile'
import Pencil from '../icons/Pencil'
import PlusIcon from '../icons/PlusIcon'
import Png from '../icons/Png'
import PowerPoint from '../icons/Ppt'
import Ppt from '../icons/Ppt'
import Profile from '../icons/Profile'
import Reload from '../icons/Reload'
import search from '../icons/Search'
import SearchingMan from '../icons/SearchingMan'
import Setting from '../icons/Setting'
import SortOrderDown from '../icons/SortOrderDown'
import SortOrderUp from '../icons/SortOrderUp'
import Svg from '../icons/Svg'
import Team from '../icons/Team'
import Telephone from '../icons/Telephone'
import Time from '../icons/Time'
import Trash from '../icons/Trash'
import Unk from '../icons/Unk'
import User from '../icons/User'
import Warning from '../icons/Warning'
import Xls from '../icons/Xls'
import Xml from '../icons/Xml'
import ZoomMinus from '../icons/ZoomMinus'
import ZoomPlus from '../icons/ZoomPlus'
import dotsList from '../icons/dotsList'

export const iconMap = {
  arrowDown: ArrowDown,
  article: Article,
  bookmark: Bookmark,
  favorites: Favorites,
  plus: PlusIcon,
  dotsMenu: Dots,
  setting: Setting,
  galleryIcon: GalleryIcon,
  dotsList: dotsList,
  home: Home,
  user: User,
  team: Team,
  pencil: Pencil,
  trash: Trash,
  circle: Circle,
  search: search,
  pdfFile: PdfFile,
  excelFile: Excel,
  docsFile: Docs,
  powerPointFile: PowerPoint,

  load: Load,
  download: Download,
  eye: Eye,
  eyeOutline: EyeOutline,
  cross: Cross,
  emptyBookmark: EmptyBookmark,
  warning: Warning,
  bell: Bell,
  done: DoneSimple,
  checkedRound: CheckedRound,
  bellOutline: BellOutline,
  house: House,
  danger: Danger,

  filter: Filter,
  calendar: Calendar,
  arrowBack: ArrowBack,
  orders: Orders,
  clients: Clients,
  knowledgePlace: KnowledgePlace,
  support: Support,
  reports: Reports,
  users: Users,
  logs: Logs,
  burgerMenu: BurgerMenu,
  question: Question,
  officeApp: OfficeApp,
  bubbleChart: BubbleChart,
  close: Close,
  flag: Flag,
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRight,
  avatar: Avatar,
  link: Link,
  cutlery: Cutlery,
  comment: Comment,
  notification: Notification,
  barChart: BarChart,
  keyAccess: KeyAccess,
  breadcrumbSeparator: BreadcrumbSeparator,
  moreMenu: MoreMenu,
  minus: Minus,
  notFound: NotFound,
  noAccess: NoAccess,
  underMaintenance: UnderMaintenance,
  someWrong: SomeWrong,
  exit: Exit,
  staff: Staff,
  emptyTable: EmptyTable,
  arrowUp: ArrowUp,
  myLocation: MyLocation,
  zoomPlus: ZoomPlus,
  zoomMinus: ZoomMinus,
  time: Time,
  cashUser: CashUser,
  telephone: Telephone,
  profile: Profile,
  loyalStatus: LoyalStatus,
  searchingMan: SearchingMan,
  reload: Reload,
  copy: Copy,
  checkedSimple: CheckedSimple,
  emptyFiles: EmptyFiles,
  png: Png,
  jpg: Jpg,
  pdf: Pdf,
  xls: Xls,
  ppt: Ppt,
  docx: Docx,
  xml: Xml,
  mp4: Mp4,
  unk: Unk,
  sortOrderDown: SortOrderDown,
  sortOrderUp: SortOrderUp,
  folder: Folder,
  file: File,
  checked: Checked,
  svg: Svg,
  jpeg: Jpeg,
  boldClose: BoldClose,
} as const
